import React from "react";

/**
 * Inline SVG icon set. Kept local so the app does not take on an icon-library
 * dependency; every glyph is drawn on the same 24x24 grid with a 1.8 stroke.
 */

function I({ size = 22, color, strokeWidth = 1.8, className, children }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={color ? { color } : undefined}
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

/* ------------------------------------------------------------------ auth -- */

export const ShieldIcon = (p) => (
  <I {...p}>
    <path d="M12 3 5 6v5.5c0 4.2 2.9 8.1 7 9.5 4.1-1.4 7-5.3 7-9.5V6l-7-3Z" />
  </I>
);

export const ShieldCheckIcon = (p) => (
  <I {...p}>
    <path d="M12 3 5 6v5.5c0 4.2 2.9 8.1 7 9.5 4.1-1.4 7-5.3 7-9.5V6l-7-3Z" />
    <path d="m9 12 2 2 4-4" />
  </I>
);

export const ShieldLockIcon = (p) => (
  <I {...p}>
    <path d="M12 3 5 6v5.5c0 4.2 2.9 8.1 7 9.5 4.1-1.4 7-5.3 7-9.5V6l-7-3Z" />
    <rect x="9.4" y="11.4" width="5.2" height="4.2" rx="1" />
    <path d="M10.6 11.4v-1.2a1.4 1.4 0 0 1 2.8 0v1.2" />
  </I>
);

/* Four nodes rather than seven — the dense version turned to mush at 20px. */
export const NetworkIcon = (p) => (
  <I {...p}>
    <path d="m10.4 10.4 3.2-3.2M10.6 13.6l-2.8 2.8M13.5 12.6l2.7 2.9" />
    <circle cx="12" cy="12" r="2.6" />
    <circle cx="16" cy="5.4" r="2.2" />
    <circle cx="6.2" cy="18" r="2.2" />
    <circle cx="17.8" cy="17.2" r="2.2" />
  </I>
);

export const BrainIcon = (p) => (
  <I {...p}>
    <path d="M12 5.4a3 3 0 0 0-5.6-.6 2.7 2.7 0 0 0-1.7 4.3 2.9 2.9 0 0 0 .5 4.3 2.8 2.8 0 0 0 2.2 4.2A2.9 2.9 0 0 0 12 18.4Z" />
    <path d="M12 5.4a3 3 0 0 1 5.6-.6 2.7 2.7 0 0 1 1.7 4.3 2.9 2.9 0 0 1-.5 4.3 2.8 2.8 0 0 1-2.2 4.2A2.9 2.9 0 0 1 12 18.4Z" />
    <path d="M12 5.4v13" />
    {/* Folds — without these the two lobes read as a plain capsule. */}
    <path d="M9.2 9.1a2 2 0 0 1-2.4.3M14.8 9.1a2 2 0 0 0 2.4.3" strokeWidth="1.5" />
    <path d="M9.4 14.2a2 2 0 0 0-2.6.4M14.6 14.2a2 2 0 0 1 2.6.4" strokeWidth="1.5" />
  </I>
);

export const ChartIcon = (p) => (
  <I {...p}>
    <path d="M5 20V13M9.7 20v-4.6M14.3 20V9.5M19 20V6" />
    <path d="m5 10.5 4.7-3.2L14.3 9 19 4.6" />
  </I>
);

export const LockIcon = (p) => (
  <I {...p}>
    <rect x="4.5" y="10.5" width="15" height="9.5" rx="2.2" />
    <path d="M8 10.5V7.8a4 4 0 0 1 8 0v2.7" />
  </I>
);

export const UserIcon = (p) => (
  <I {...p}>
    <circle cx="12" cy="8" r="3.5" />
    <path d="M4.8 20a7.2 7.2 0 0 1 14.4 0" />
  </I>
);

export const GlobeIcon = (p) => (
  <I {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M3.5 12h17M12 3.5c2.2 2.3 3.4 5.3 3.4 8.5s-1.2 6.2-3.4 8.5c-2.2-2.3-3.4-5.3-3.4-8.5S9.8 5.8 12 3.5Z" />
  </I>
);

export const EyeIcon = (p) => (
  <I {...p}>
    <path d="M2.5 12S6 5.8 12 5.8 21.5 12 21.5 12 18 18.2 12 18.2 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="3" />
  </I>
);

export const EyeOffIcon = (p) => (
  <I {...p}>
    <path d="M10.6 6a9.8 9.8 0 0 1 1.4-.1c6 0 9.5 6.1 9.5 6.1a17 17 0 0 1-3 3.8M6.2 7.8A16.7 16.7 0 0 0 2.5 12S6 18.2 12 18.2c1.6 0 3-.4 4.3-1" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2M3.5 3.5l17 17" />
  </I>
);

export const InfoIcon = (p) => (
  <I {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 11v5.2" />
    <path d="M12 7.9v.1" strokeWidth="2.4" />
  </I>
);

export const BackIcon = (p) => (
  <I {...p}>
    <path d="M14.5 4.8h3a2 2 0 0 1 2 2v10.4a2 2 0 0 1-2 2h-3" />
    <path d="M9.5 8.5 6 12l3.5 3.5M6 12h8.5" />
  </I>
);

/* ------------------------------------------------------------- navigation -- */

export const HomeIcon = (p) => (
  <I {...p}>
    <path d="M4 10.5 12 4l8 6.5V19a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19v-8.5Z" />
    <path d="M9.5 20.5v-6h5v6" />
  </I>
);

export const UsersIcon = (p) => (
  <I {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3.4 19.5a5.6 5.6 0 0 1 11.2 0" />
    <path d="M16 5.2a3.2 3.2 0 0 1 0 5.9M17.4 14.6a5.6 5.6 0 0 1 3.2 4.9" />
  </I>
);

export const IdCardIcon = (p) => (
  <I {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2.2" />
    <circle cx="9" cy="11" r="2.1" />
    <path d="M5.9 16.4a3.4 3.4 0 0 1 6.2 0M14.5 10h4M14.5 13.4h4" />
  </I>
);

export const PlugIcon = (p) => (
  <I {...p}>
    <path d="M9.5 13.5 6.8 16.2a3.8 3.8 0 0 0 5.4 5.4l2.7-2.7" strokeWidth="1.8" />
    <path d="M14.5 10.5l2.7-2.7a3.8 3.8 0 0 0-5.4-5.4L9.1 5.1" />
    <path d="m10 14 4-4" />
  </I>
);

export const ReportIcon = (p) => (
  <I {...p}>
    <path d="M6 3.5h7.5L18.5 8v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1Z" />
    <path d="M13.2 3.6V8.3h4.9M9 13.5v3.8M12 11.5v5.8M15 14.8v2.5" />
  </I>
);

export const SettingsIcon = (p) => (
  <I {...p}>
    <circle cx="12" cy="12" r="2.9" />
    <path d="M19.4 14.4a1.6 1.6 0 0 0 .3 1.8l.1.1a1.9 1.9 0 1 1-2.7 2.7l-.1-.1a1.6 1.6 0 0 0-2.7 1.1v.3a1.9 1.9 0 1 1-3.8 0v-.2a1.6 1.6 0 0 0-2.8-1.1l-.1.1a1.9 1.9 0 1 1-2.7-2.7l.1-.1a1.6 1.6 0 0 0-1.1-2.7h-.3a1.9 1.9 0 1 1 0-3.8h.2a1.6 1.6 0 0 0 1.1-2.8l-.1-.1a1.9 1.9 0 1 1 2.7-2.7l.1.1a1.6 1.6 0 0 0 2.7-1.1v-.3a1.9 1.9 0 1 1 3.8 0v.2a1.6 1.6 0 0 0 2.8 1.1l.1-.1a1.9 1.9 0 1 1 2.7 2.7l-.1.1a1.6 1.6 0 0 0 1.1 2.7h.3a1.9 1.9 0 1 1 0 3.8h-.2a1.6 1.6 0 0 0-1.4 1Z" />
  </I>
);

export const AuditIcon = (p) => (
  <I {...p}>
    <circle cx="10.8" cy="10.8" r="6.3" />
    <path d="m15.4 15.4 4.3 4.3" />
    <path d="M8.6 12.4v-2M10.8 12.4V8.9M13 12.4v-1.2" />
  </I>
);

/* ---------------------------------------------------------------- chrome -- */

export const MenuIcon = (p) => (
  <I {...p} strokeWidth={2}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </I>
);

export const SearchIcon = (p) => (
  <I {...p}>
    <circle cx="11" cy="11" r="6.5" />
    <path d="m16 16 4 4" />
  </I>
);

export const BellIcon = (p) => (
  <I {...p}>
    <path d="M18 9a6 6 0 1 0-12 0c0 5-2 6.5-2 6.5h16S18 14 18 9Z" />
    <path d="M13.7 19a2 2 0 0 1-3.4 0" />
  </I>
);

export const ChevronDownIcon = (p) => (
  <I {...p}>
    <path d="m6 9.5 6 6 6-6" />
  </I>
);

export const ChevronRightIcon = (p) => (
  <I {...p}>
    <path d="m9.5 6 6 6-6 6" />
  </I>
);

export const ArrowRightIcon = (p) => (
  <I {...p}>
    <path d="M4.5 12h15M13.5 6l6 6-6 6" />
  </I>
);

export const ArrowUpRightIcon = (p) => (
  <I {...p} strokeWidth={2.2}>
    <path d="M7 17 17 7M8.5 7H17v8.5" />
  </I>
);

export const DownloadIcon = (p) => (
  <I {...p}>
    <path d="M12 4v10.5M7.5 10.5 12 15l4.5-4.5" />
    <path d="M4.5 17.5v1a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-1" />
  </I>
);

export const CalendarIcon = (p) => (
  <I {...p}>
    <rect x="3.5" y="5" width="17" height="15.5" rx="2.2" />
    <path d="M3.5 9.8h17M8.3 3.5v3M15.7 3.5v3" />
  </I>
);

export const MoreIcon = (p) => (
  <I {...p} strokeWidth={2.4}>
    <path d="M12 6.2v.1M12 12v.1M12 17.8v.1" />
  </I>
);

/* ------------------------------------------------------------------ data -- */

export const DatabaseIcon = (p) => (
  <I {...p}>
    <ellipse cx="12" cy="6.2" rx="7.5" ry="2.9" />
    <path d="M4.5 6.2v11.6c0 1.6 3.4 2.9 7.5 2.9s7.5-1.3 7.5-2.9V6.2" />
    <path d="M4.5 12c0 1.6 3.4 2.9 7.5 2.9s7.5-1.3 7.5-2.9" />
  </I>
);

export const AlertTriangleIcon = (p) => (
  <I {...p}>
    <path d="M10.7 4.2 3.3 17a1.5 1.5 0 0 0 1.3 2.3h14.8a1.5 1.5 0 0 0 1.3-2.3L13.3 4.2a1.5 1.5 0 0 0-2.6 0Z" />
    <path d="M12 9.5v3.8M12 16.4v.1" strokeWidth="2.1" />
  </I>
);

export const AlertCircleIcon = (p) => (
  <I {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.8v4.6M12 15.9v.1" strokeWidth="2.1" />
  </I>
);

export const CopyIcon = (p) => (
  <I {...p}>
    <rect x="8.5" y="3.5" width="12" height="12" rx="2" />
    <path d="M15.5 18.5a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2" />
  </I>
);

export const MissingDataIcon = (p) => (
  <I {...p}>
    <rect
      x="3.8"
      y="3.8"
      width="16.4"
      height="16.4"
      rx="2.6"
      strokeDasharray="3.4 3"
    />
  </I>
);

export const ConflictIcon = (p) => (
  <I {...p}>
    <circle cx="7.2" cy="7.4" r="2.9" />
    <circle cx="16.8" cy="7.4" r="2.9" />
    <circle cx="12" cy="17.4" r="2.9" />
    <path d="M9.6 9.6 12 14M14.4 9.6 12 14" />
  </I>
);

export const ClockIcon = (p) => (
  <I {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.2V12l3.2 2" />
  </I>
);

export const SyncIcon = (p) => (
  <I {...p}>
    <path d="M20 12a8 8 0 0 1-13.7 5.6L4 15.4" />
    <path d="M4 12a8 8 0 0 1 13.7-5.6L20 8.6" />
    <path d="M4 20v-4.6h4.6M20 4v4.6h-4.6" />
  </I>
);

export const BriefcaseIcon = (p) => (
  <I {...p}>
    <rect x="3.2" y="7.2" width="17.6" height="13" rx="2.2" />
    <path d="M8.8 7.2V5.6a2 2 0 0 1 2-2h2.4a2 2 0 0 1 2 2v1.6M3.2 12.6h17.6" />
  </I>
);

/* --------------------------------------------------------------- registry -- */

export const PlusIcon = (p) => (
  <I {...p} strokeWidth={2.2}>
    <path d="M12 5v14M5 12h14" />
  </I>
);

export const FilterIcon = (p) => (
  <I {...p}>
    <path d="M3.6 5.2h16.8l-6.5 7.6v5.4l-3.8 2.2v-7.6L3.6 5.2Z" />
  </I>
);

export const ChevronLeftIcon = (p) => (
  <I {...p}>
    <path d="M14.5 6l-6 6 6 6" />
  </I>
);

export const ChevronsLeftIcon = (p) => (
  <I {...p}>
    <path d="M11.5 6l-6 6 6 6M18.5 6l-6 6 6 6" />
  </I>
);

export const ChevronsRightIcon = (p) => (
  <I {...p}>
    <path d="M12.5 6l6 6-6 6M5.5 6l6 6-6 6" />
  </I>
);

export const EditIcon = (p) => (
  <I {...p}>
    <path d="M4.5 19.5h4l10-10a2.1 2.1 0 0 0-3-3l-10 10v3Z" />
    <path d="m14.5 6.5 3 3" />
  </I>
);

export const NoteIcon = (p) => (
  <I {...p}>
    <path d="M6 3.5h7.5L18.5 8v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1Z" />
    <path d="M13.2 3.6V8.3h4.9" />
    <path d="M12 11.6v5M9.5 14.1h5" />
  </I>
);

export const DocCheckIcon = (p) => (
  <I {...p}>
    <path d="M6 3.5h7.5L18.5 8v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1Z" />
    <path d="M13.2 3.6V8.3h4.9" />
    <path d="m9.3 14.6 1.9 1.9 3.5-3.6" />
  </I>
);

export const ReceiptIcon = (p) => (
  <I {...p}>
    <path d="M6 3.5h12v17l-2.4-1.6-2.4 1.6-2.4-1.6L8.4 20.5 6 18.9V3.5Z" />
    <path d="M9.3 8h5.4M9.3 12h5.4" />
  </I>
);

export const CreditCardIcon = (p) => (
  <I {...p}>
    <rect x="3" y="5.5" width="18" height="13" rx="2.2" />
    <path d="M3 10h18M6.6 14.6h3.2" />
  </I>
);

export const BuildingIcon = (p) => (
  <I {...p}>
    <path d="M4.5 20.5V5.2a1.5 1.5 0 0 1 1.5-1.5h7a1.5 1.5 0 0 1 1.5 1.5v15.3" />
    <path d="M14.5 10h3.8a1.5 1.5 0 0 1 1.5 1.5v9M3 20.5h18" />
    <path d="M7.6 7.5h3.4M7.6 11.4h3.4M7.6 15.3h3.4" />
  </I>
);

export const BankIcon = (p) => (
  <I {...p}>
    <path d="M3.5 9.5 12 4.5l8.5 5" />
    <path d="M5.6 9.5v8.4M10 9.5v8.4M14 9.5v8.4M18.4 9.5v8.4M3.2 20.5h17.6" />
  </I>
);

export const AnchorIcon = (p) => (
  <I {...p}>
    <circle cx="12" cy="5.6" r="2.1" />
    <path d="M12 7.7v12.1M8.4 11h7.2" />
    <path d="M4.6 14.4a7.5 7.5 0 0 0 14.8 0" />
  </I>
);

export const CheckCircleIcon = (p) => (
  <I {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="m8.4 12.2 2.4 2.4 4.8-4.9" />
  </I>
);

export const TrendUpIcon = (p) => (
  <I {...p}>
    <path d="m3.8 16.4 5-5 3.4 3.4 6-6" />
    <path d="M14.4 8.8h3.8v3.8" />
  </I>
);

export const ScaleIcon = (p) => (
  <I {...p}>
    <path d="M12 4.6v15M7 19.6h10" />
    <path d="M5.2 7.6 12 6l6.8 1.6" />
    <path d="M5.2 7.6 2.8 13a2.6 2.6 0 0 0 4.8 0L5.2 7.6ZM18.8 7.6 16.4 13a2.6 2.6 0 0 0 4.8 0l-2.4-5.4Z" />
  </I>
);

export const XIcon = (p) => (
  <I {...p} strokeWidth={2}>
    <path d="M6 6l12 12M18 6L6 18" />
  </I>
);

export const XCircleIcon = (p) => (
  <I {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M9.2 9.2l5.6 5.6M14.8 9.2l-5.6 5.6" />
  </I>
);

export const MergeIcon = (p) => (
  <I {...p}>
    <path d="M7 20V9.5a4 4 0 0 1 4-4h6" />
    <path d="M14 2.5 17.5 5.5 14 8.5" />
    <path d="M7 14.5a4 4 0 0 0 4 4h6" />
    <path d="M14 15.5 17.5 18.5 14 21.5" />
  </I>
);

export const ShareIcon = (p) => (
  <I {...p}>
    <circle cx="17.5" cy="6" r="2.6" />
    <circle cx="6.5" cy="12" r="2.6" />
    <circle cx="17.5" cy="18" r="2.6" />
    <path d="m8.9 10.8 6.3-3.5M8.9 13.2l6.3 3.5" />
  </I>
);

export const ExpandIcon = (p) => (
  <I {...p}>
    <path d="M9 4.5H4.5V9M15 4.5h4.5V9M9 19.5H4.5V15M15 19.5h4.5V15" />
  </I>
);

export const UserCheckIcon = (p) => (
  <I {...p}>
    <circle cx="10" cy="8" r="3.4" />
    <path d="M3.6 19.6a6.4 6.4 0 0 1 12.1-2.9" />
    <path d="m15.6 17.6 1.8 1.8 3.2-3.4" />
  </I>
);

export const SparkleIcon = (p) => (
  <I {...p}>
    <path d="M12 3.2 13.7 8l4.8 1.7-4.8 1.7L12 16.2l-1.7-4.8L5.5 9.7 10.3 8 12 3.2Z" />
    <path d="M18.4 15.4l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7.7-2Z" />
  </I>
);

export const LightbulbIcon = (p) => (
  <I {...p}>
    <path d="M9.2 17.2a6 6 0 1 1 5.6 0v1.6a1.6 1.6 0 0 1-1.6 1.6h-2.4a1.6 1.6 0 0 1-1.6-1.6v-1.6Z" />
    <path d="M9.4 17.2h5.2" />
  </I>
);

export const PulseIcon = (p) => (
  <I {...p}>
    <path d="M3 12.4h3.4l2.2-6 3.4 12 2.4-8.4 1.6 2.4H21" />
  </I>
);

export const BarsIcon = (p) => (
  <I {...p}>
    <path d="M5.5 20V11M12 20V4.5M18.5 20v-6.4" />
  </I>
);

export const TransferIcon = (p) => (
  <I {...p}>
    <path d="M4 9h14M14.5 5.5 18 9l-3.5 3.5" />
    <path d="M20 15H6M9.5 11.5 6 15l3.5 3.5" />
  </I>
);

export const LinkIcon = (p) => (
  <I {...p}>
    <path d="M10.2 13.8a3.6 3.6 0 0 0 5.1 0l3-3a3.6 3.6 0 0 0-5.1-5.1l-1.2 1.2" />
    <path d="M13.8 10.2a3.6 3.6 0 0 0-5.1 0l-3 3a3.6 3.6 0 0 0 5.1 5.1l1.2-1.2" />
  </I>
);

/* ------------------------------------------------------------ registration -- */

export const ArrowLeftIcon = (p) => (
  <I {...p}>
    <path d="M19.5 12h-15M10.5 6l-6 6 6 6" />
  </I>
);

export const SaveIcon = (p) => (
  <I {...p}>
    <path d="M5.5 4.5h10L19.5 8.5v11a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-14a1 1 0 0 1 1-1Z" />
    <path d="M8.5 4.5v5h6v-5M8 20.5v-5.4h8v5.4" />
  </I>
);

export const SendIcon = (p) => (
  <I {...p}>
    <path d="M20.5 3.5 10.8 13.2M20.5 3.5l-6.2 17-3.5-7.3-7.3-3.5 17-6.2Z" />
  </I>
);

export const UploadIcon = (p) => (
  <I {...p}>
    <path d="M12 15.5V4.5M7.5 9 12 4.5 16.5 9" />
    <path d="M4.5 17.5v1a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-1" />
  </I>
);

export const MapPinIcon = (p) => (
  <I {...p}>
    <path d="M12 21s7-5.6 7-11a7 7 0 1 0-14 0c0 5.4 7 11 7 11Z" />
    <circle cx="12" cy="10" r="2.6" />
  </I>
);

export const FolderIcon = (p) => (
  <I {...p}>
    <path d="M3.5 7a1.5 1.5 0 0 1 1.5-1.5h4l2 2.4h7.5A1.5 1.5 0 0 1 20 9.4v9.1a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5V7Z" />
  </I>
);

export const FileIcon = (p) => (
  <I {...p}>
    <path d="M6 3.5h7.5L18.5 8v12a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1Z" />
    <path d="M13.2 3.6V8.3h4.9" />
  </I>
);

export const MailIcon = (p) => (
  <I {...p}>
    <rect x="3" y="5.5" width="18" height="13" rx="2" />
    <path d="m3.6 6.8 8.4 6 8.4-6" />
  </I>
);

export const PhoneIcon = (p) => (
  <I {...p}>
    <path d="M7.4 3.8 9.6 8l-2 1.9a12.5 12.5 0 0 0 6.5 6.5l1.9-2 4.2 2.2v3.1a1.6 1.6 0 0 1-1.8 1.6C10.7 20.4 3.6 13.3 2.7 5.6A1.6 1.6 0 0 1 4.3 3.8h3.1Z" />
  </I>
);

export const ExternalLinkIcon = (p) => (
  <I {...p}>
    <path d="M13.5 4.5h6v6M19.5 4.5 11 13" />
    <path d="M18 14v5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 19V8a1.5 1.5 0 0 1 1.5-1.5H10" />
  </I>
);

export const StarIcon = (p) => (
  <I {...p}>
    <path d="m12 4 2.4 5 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4L4.2 9.8 9.6 9 12 4Z" />
  </I>
);

/* -------------------------------------------------------- data integration -- */

export const PlayIcon = (p) => (
  <I {...p}>
    <path d="M8.5 5.6 18 12l-9.5 6.4V5.6Z" />
  </I>
);

export const HistoryIcon = (p) => (
  <I {...p}>
    <path d="M3.6 12a8.4 8.4 0 1 0 2.6-6.1" />
    <path d="M3.5 4.4v4.2h4.2" />
    <path d="M12 7.6V12l3 1.9" />
  </I>
);

export const CloudUploadIcon = (p) => (
  <I {...p}>
    <path d="M7 18.5a4 4 0 0 1-.4-8A5.5 5.5 0 0 1 17.4 9.6a3.9 3.9 0 0 1 .6 7.8" />
    <path d="M12 20.5v-8M9.2 15 12 12.2 14.8 15" />
  </I>
);

export const CloudIcon = (p) => (
  <I {...p}>
    <path d="M7.2 19a4.4 4.4 0 0 1-.4-8.8A5.8 5.8 0 0 1 18 9a4.3 4.3 0 0 1-.7 10H7.2Z" />
  </I>
);

export const ServerIcon = (p) => (
  <I {...p}>
    <rect x="3.2" y="4.5" width="17.6" height="6" rx="1.8" />
    <rect x="3.2" y="13.5" width="17.6" height="6" rx="1.8" />
    <path d="M6.8 7.5h.1M6.8 16.5h.1" strokeWidth="2.2" />
  </I>
);

export const GridIcon = (p) => (
  <I {...p}>
    <rect x="4" y="4" width="7" height="7" rx="1.5" />
    <rect x="13" y="4" width="7" height="7" rx="1.5" />
    <rect x="4" y="13" width="7" height="7" rx="1.5" />
    <rect x="13" y="13" width="7" height="7" rx="1.5" />
  </I>
);

export const SheetIcon = (p) => (
  <I {...p}>
    <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
    <path d="M3.5 9.5h17M9.5 9.5v10M15 9.5v10" />
  </I>
);

export const PlugConnectIcon = (p) => (
  <I {...p}>
    <path d="M9 3.5v5M15 3.5v5" />
    <path d="M6.5 8.5h11v3a5.5 5.5 0 0 1-11 0v-3Z" />
    <path d="M12 17v3.5" />
  </I>
);

export const SortIcon = (p) => (
  <I {...p}>
    <path d="M8 9.5 12 5.5l4 4M8 14.5l4 4 4-4" />
  </I>
);

export const SessionIcon = (p) => (
  <I {...p}>
    <rect x="3.5" y="4.5" width="17" height="12" rx="2" />
    <path d="M8 20.5h8M12 16.5v4" />
  </I>
);

export const LogOutIcon = (p) => (
  <I {...p}>
    <path d="M9.5 4.8h-3a2 2 0 0 0-2 2v10.4a2 2 0 0 0 2 2h3" />
    <path d="M15 8.5 18.5 12 15 15.5M18.5 12H10" />
  </I>
);

export const KeyIcon = (p) => (
  <I {...p}>
    <circle cx="8" cy="8" r="3.6" />
    <path d="m10.6 10.6 8 8M16.4 16.4l-1.9 1.9M18.6 14.2l-1.9 1.9" />
  </I>
);
